import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../redux/store";

export interface ThemeState {
  value: string;
}

const initialState: ThemeState = {
  // value: getThemeFromLocalStorage(),
  value: localStorage.theme,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
      // setThemeInLocalStorage(state.value);
    },
  },
});

export const { setTheme } = themeSlice.actions;

export const selectTheme = (state: RootState) => state;

export default themeSlice.reducer;
